import React, { useState } from "react"
import { Paper, Grid } from "@material-ui/core"
import {
  InputCheckboxMaster,
  InputOptionMaster,
  InputTextMaster,
  MasterButton,
} from "App/Component/ui"
import { RESET_STATE_ASURANSI, STYLE_TAB_ASURANSI } from "."
import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  instance2,
  TYPE_INSTANCE1,
  TYPE_INSTANCE4,
} from "App/constants"
import {
  defaultToastError,
  defaultToastSuccess,
  isNull,
} from "App/utils/helpers"
import { useSelectOption } from "App/hooks"
import { LIST_URL_MASTER } from "utils/masters"

export default function FormTabAsuransi({ formData, setFormData, run }) {
  const classes = STYLE_TAB_ASURANSI()

  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT)
  const jenisHarga = useSelectOption(
    false,
    LIST_URL_MASTER.asuransi.jenis_harga,
    TYPE_INSTANCE4,
    "id",
    "name",
    "data",
  )

  const bank = useSelectOption(
    false,
    "/bank/listbank",
    TYPE_INSTANCE1,
    "name",
    "name",
    "body",
  )

  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    })
  }

  const addAsuransi = async () => {
    return instance2.post(LIST_URL_MASTER.asuransi.add, {
      ...formData,
    })
  }

  const updateAsuransi = () => {
    return instance2.post(
      LIST_URL_MASTER.asuransi.update,
      {
        ...formData,
      },
      {
        headers: {
          idinsurance: formData.id,
        },
      },
    )
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setDisabled(DISABLED_BUTTON_SUBMIT)
    if (formData.name === "") {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
      defaultToastError("Nama atau Kode tidak boleh kosong")
    } else {
      try {
        if (formData.id === "") {
          await addAsuransi()
          defaultToastSuccess("Berhasil menambah Asuransi")
        } else if (formData.id !== "") {
          await updateAsuransi()
          defaultToastSuccess("Berhasil mengubah Asuransi")
        }
        run(!run)
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
        setFormData(RESET_STATE_ASURANSI)
      } catch (error) {
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
        defaultToastError(error?.response?.data?.message)
      }
    }
  }

  return (
    <Paper className={classes.paper}>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <div>
          <p>ID ASURANSI</p>

          <div
            style={{
              paddingTop: "1rem",
              fontWeight: "600",
              fontSize: "20px",
            }}
          >
            {formData.id === "" ? "-" : formData.id}
          </div>
        </div>
        <InputCheckboxMaster
          checked={formData.status}
          name="status"
          id="status"
          label="Aktif"
          onChange={() =>
            setFormData({ ...formData, status: !formData.status })
          }
        />
      </Grid>
      <br />
      <form onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={3}>
          <Grid item xs={6} sm={4}>
            <InputTextMaster
              name="name"
              label="Nama"
              id="name"
              value={formData.name}
              onChange={handleChange("name")}
              placeholder="Nama"
              error={true}
              message={"Wajib Diisi"}
            />
          </Grid>
          <Grid item xs={6} sm={4}>
            <InputTextMaster
              name="phone"
              label="No Tlp Perusahaan"
              id="phone"
              value={formData.phone}
              onChange={handleChange("phone")}
              placeholder="NO TLP PERUSAHAAN"
              error={true}
              message={"Wajib Diisi"}
            />
          </Grid>
          <Grid item xs={6} sm={4}>
            <InputOptionMaster
              name="harga_id"
              label="JENIS HARGA"
              id="harga_id"
              withSearch={false}
              value={formData.harga_id}
              onChange={handleChange("harga_id")}
              data={jenisHarga}
            />
          </Grid>

          <Grid item sm={8}>
            <InputTextMaster
              name="address"
              label="ALAMAT"
              id="address"
              placeholder="Alamat Perusahaan"
              value={formData.address}
              onChange={handleChange("address")}
              error={true}
              message={"Wajib Diisi"}
            />
          </Grid>

          <Grid item xs={6} sm={4}>
            <InputOptionMaster
              name="insurance_type_id"
              label="TIPE ASURANSI"
              id="insurance_type_id"
              withSearch={false}
              value={formData.insurance_type_id}
              onChange={handleChange("insurance_type_id")}
              data={[
                {
                  label: "UMUM",
                  value: 1,
                },
                {
                  label: "BPJS",
                  value: 2,
                },
                {
                  label: "ASURANSI KESEHATAN",
                  value: 3,
                },
                {
                  label: "ASURANSI PERUSAHAAN",
                  value: 4,
                },
              ]}
            />
          </Grid>
        </Grid>
        <p className="fw-600 mt-2">Virtual Account Transfer (VA)</p>
        <div className="mt-1">
          <Grid container spacing={3}>
            <Grid item xs={4} sm={4}>
              <InputOptionMaster
                name="bank"
                label="BANK"
                id="bank"
                withSearch={true}
                value={formData.nama_bank}
                labelValue={formData.nama_bank}
                onChange={(e) => {
                  isNull(e)
                    ? setFormData({
                        ...formData,
                        nama_bank: "",
                      })
                    : setFormData({
                        ...formData,
                        nama_bank: e.value,
                      })
                }}
                data={bank}
                needPars={false}
              />
            </Grid>
            <Grid item xs={4} sm={4}>
              <InputTextMaster
                name="no_virtual_account"
                label="Nomor Virtual Account"
                id="no_virtual_account"
                value={formData.no_virtual_account}
                onChange={handleChange("no_virtual_account")}
                placeholder="No Virtual Account"
                error={true}
                message={"Wajib Diisi"}
              />
            </Grid>
            <Grid item xs={4} sm={4}>
              <InputTextMaster
                name="nama_virtual_account"
                label="Nama Virtual Account"
                id="nama_virtual_account"
                placeholder="Nama Virtual Account"
                value={formData.nama_virtual_account}
                onChange={handleChange("nama_virtual_account")}
                error={true}
                message={"Wajib Diisi"}
              />
            </Grid>
          </Grid>
        </div>
        <p className="fw-600 mt-2">Kontak Person (KP)</p>
        <div className="mt-1">
          <Grid container spacing={3}>
            <Grid item xs={6} sm={4}>
              <InputTextMaster
                name="contactperson"
                label="Nama"
                id="contactperson"
                value={formData.contactperson}
                onChange={handleChange("contactperson")}
                placeholder="Nama"
                error={true}
                message={"Wajib Diisi"}
              />
            </Grid>
            <Grid item xs={6} sm={4}>
              <InputTextMaster
                name="cpphone"
                label="NO. TELEPON KP"
                id="cpphone"
                placeholder="No. Telepon KP"
                value={formData.cpphone}
                onChange={handleChange("cpphone")}
                error={true}
                message={"Wajib Diisi"}
              />
            </Grid>
            <Grid item xs={6} sm={4}>
              <InputTextMaster
                name="cpmobilephone"
                label="NO. MOBILE PHONE"
                id="cpmobilephone"
                placeholder="No. Mobile Phone"
                value={formData.cpmobilephone}
                onChange={handleChange("cpmobilephone")}
                error={true}
                message={"Wajib Diisi"}
              />
            </Grid>

            <Grid item xs={4} sm={4}>
              <InputTextMaster
                name="cpemail"
                label="EMAIL KP"
                id="cpemail"
                placeholder="Email KP"
                value={formData.cpemail}
                onChange={handleChange("cpemail")}
                error={true}
                message={"Wajib Diisi"}
              />
            </Grid>

            <Grid item xs={8} sm={8}>
              <InputTextMaster
                name="cpaddress"
                label="ALAMAT KP"
                id="cpaddress"
                placeholder="Alamat KP"
                value={formData.cpaddress}
                onChange={handleChange("cpaddress")}
                error={true}
                message={"Wajib Diisi"}
              />
            </Grid>
          </Grid>
        </div>
        <div className="mt-2">
          <hr style={{ margin: "1rem 0", opacity: "0.3" }} />
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <MasterButton
              outline={true}
              type={"button"}
              onClick={() => {
                setFormData(RESET_STATE_ASURANSI)
              }}
              color="danger"
              name="Reset"
              size="md"
            />
            <MasterButton
              outline={false}
              type={"submit"}
              color={disabled.color}
              name={disabled.label}
              size="md"
            />
          </Grid>
        </div>
      </form>
    </Paper>
  )
}
